import { PlayerData } from "@/types/player"
import { usePlayerGroupsQuery } from "@/hooks/api/useSettingQuery"
import { createGlobalStore } from "@/stores/global"
import Selector from "@/components/form/selector/Selector"

import { useMemo } from "react"

export default function PlayerRpeListItem(
  props: PlayerData & {
    updatePlayerRpe: (item: PlayerData) => void
  },
) {
  const { positionList } = createGlobalStore((state) => ({ positionList: state.positionList }))
  const { data: playerGroupList } = usePlayerGroupsQuery()

  const positionListOptions = useMemo(() => {
    return positionList.map((item) => ({
      label: item.code,
      value: item.code,
    }))
  }, [positionList])

  const playerGroupListOptions = useMemo(() => {
    return (playerGroupList?.teamPlayerGroups || [])?.map((item) => ({
      label: item.name,
      value: item.idfTeamPlayerGroup,
    }))
  }, [playerGroupList])

  const rpeListOptions: Record<string, string | number>[] = Array(11)
    .fill(0)
    .map((_, index) => ({
      label: index,
      value: index,
    }))

  rpeListOptions.unshift({
    label: "-",
    value: "-",
  })

  return (
    <div className="PlayerRpeListItem">
      <span className="PlayerRpeListItem-name">
        {props.playerNumber} {props.playerName}
      </span>
      <Selector
        options={positionListOptions.map((item) => item.label.toString())}
        defaultValue={props.position || "-"}
        onChange={(_, option) => {
          props.updatePlayerRpe({ ...props, position: option })
        }}
      />
      <Selector
        options={playerGroupListOptions}
        value={
          (playerGroupList?.teamPlayerGroups || []).find(
            (item) => item.idfTeamPlayerGroup === props.idfTeamPlayerGroup,
          )?.name || "-"
        }
        onChange={(_, option) => {
          props.updatePlayerRpe({ ...props, idfTeamPlayerGroup: option.value })
        }}
      />
      <Selector
        options={rpeListOptions.map((item) => item.label.toString())}
        value={props.rpe?.toString() || "-"}
        onChange={(_, option) => {
          props.updatePlayerRpe({ ...props, rpe: option !== "-" ? Number(option) : undefined })
        }}></Selector>
    </div>
  )
}
